"use client"
import React from 'react'

const YoutubeEmbeded = ({ url }: { url: string }) => {
    const [id, setId] = React.useState<string>()

    React.useEffect(() => {
        setId(url.split("?v=").at(-1))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return id ? (
        <iframe
            width="100%"
            height="450"
            src={`https://www.youtube.com/embed/${id}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
    ) : null
}
export default YoutubeEmbeded